import { useQuery } from '@tanstack/react-query'
import { fetchIssueSummary } from '@services/api/wizardAPI'

export const useIssueSummaryQuery = (sourceId: string) => {
  return useQuery({
    queryKey: ['issueSummary', { sourceId }],
    queryFn: async () => fetchIssueSummary(sourceId),
    initialData: {
      issues: [],
    },
    refetchOnWindowFocus: false
  })
}
